import { render } from "./News24.vue?vue&type=template&id=5d457ccc&scoped=true"
import script from "./News24.vue?vue&type=script&lang=js"
export * from "./News24.vue?vue&type=script&lang=js"

import "./News24.vue?vue&type=style&index=0&id=5d457ccc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d457ccc"]])

export default __exports__